import clamp from 'lodash-es/clamp'

export function getChartAnchoredTooltipLeft({ plotArea, width, x }) {
  const maxLeft = Math.max(plotArea.x, plotArea.x + plotArea.width - width)

  return clamp(x - width / 2, plotArea.x, maxLeft)
}
